export const climate_environment_sustainability = [
  {
    id: 1,
    name: 'Climate Change Response Strategy_M&E Report_2015-16',
    summary: 'shortsummary/Climate Change Response Strategy_M&E Report_2015-16.html',
    link: 'Climate Change Response Strategy_M&E Report_2015-16.pdf',
    audio_en: 'audio/en/Climate Change Response Strategy_M&E Report_2015-16_en.mp3',
    audio_af: 'audio/af/Climate Change Response Strategy_M&E Report_2015-16_af.mp3',
    audio_xh: 'audio/xh/Climate Change Response Strategy_M&E Report_2015-16_xh.mp3'
  },
  {
    id: 2,
    name: 'Climate Science Input into Municipal Plans_Report_2014_0',
    summary: 'shortsummary/Climate Science Input into Municipal Plans_Report_2014_0.html',
    link: 'Climate Science Input into Municipal Plans_Report_2014_0.pdf',
    audio_en: 'audio/en/Climate Science Input into Municipal Plans_Report_2014_0_en.mp3',
    audio_af: 'audio/af/Climate Science Input into Municipal Plans_Report_2014_0_af.mp3',
    audio_xh: 'audio/xh/Climate Science Input into Municipal Plans_Report_2014_0_xh.mp3'
  },
  {
    id: 3,
    name: 'Energy Consumption &CO2e Emissions Database WC - Web',
    summary: 'shortsummary/Energy Consumption and CO2e Emissions Database WC - Web.html',
    link: 'Energy Consumption &CO2e Emissions Database WC - Web.pdf',
    audio_en: 'audio/en/Energy Consumption &CO2e Emissions Database WC - Web_en.mp3',
    audio_af: 'audio/af/Energy Consumption &CO2e Emissions Database WC - Web_af.mp3',
    audio_xh: 'audio/xh/Energy Consumption &CO2e Emissions Database WC - Web_xh.mp3'
  },
  {
    id: 4,
    name: 'GBCSA-Certification-Pricing-Brochure-FA',
    summary: 'shortsummary/GBCSA-Certification-Pricing-Brochure-FA.html',
    link: 'GBCSA-Certification-Pricing-Brochure-FA.pdf',
    audio_en: 'audio/en/GBCSA-Certification-Pricing-Brochure-FA_en.mp3',
    audio_af: 'audio/af/GBCSA-Certification-Pricing-Brochure-FA_af.mp3',
    audio_xh: 'audio/xh/GBCSA-Certification-Pricing-Brochure-FA_xh.mp3'
  },
  {
    id: 5,
    name: 'Green_Economy_Report 2022_Final',
    summary: 'shortsummary/Green_Economy_Report 2022_Final.html',
    link: 'Green_Economy_Report 2022_Final.pdf',
    audio_en: 'audio/en/Green_Economy_Report 2022_Final_en.mp3',
    audio_af: 'audio/af/Green_Economy_Report 2022_Final_af.mp3',
    audio_xh: 'audio/xh/Green_Economy_Report 2022_Final_xh.mp3'
  },
  {
    id: 6,
    name: 'NDC September 2021',
    summary: 'shortsummary/NDC_September_2021.html',
    link: 'NDC September 2021.pdf',
    audio_en: 'audio/en/NDC September 2021_en.mp3',
    audio_af: 'audio/af/NDC September 2021_af.mp3',
    audio_xh: 'audio/xh/NDC September 2021_xh.mp3'
  },
  {
    id: 7,
    name: 'STATE OF ENVIRONMENT OUTLOOK REPORT FOR THE WESTERN CAPE 2013',
    summary: 'shortsummary/STATE OF ENVIRONMENT OUTLOOK REPORT FOR THE WESTERN CAPE 2013.html',
    link: 'STATE OF ENVIRONMENT OUTLOOK REPORT FOR THE WESTERN CAPE 2013.pdf',
    audio_en: 'audio/en/STATE OF ENVIRONMENT OUTLOOK REPORT FOR THE WESTERN CAPE 2013_en.mp3',
    audio_af: 'audio/af/STATE OF ENVIRONMENT OUTLOOK REPORT FOR THE WESTERN CAPE 2013_af.mp3',
    audio_xh: 'audio/xh/STATE OF ENVIRONMENT OUTLOOK REPORT FOR THE WESTERN CAPE 2013_xh.mp3'
  },
  {
    id: 8,
    name: 'WC Climate Change Response Strategy Biennial M&E Report (2017-18)_1',
    summary: 'shortsummary/WC_Climate_Change_Response_Strategy_Biennial_M&E_Report_(2017-18)_1.html',
    link: 'WC Climate Change Response Strategy Biennial M&E Report (2017-18)_1 (1).pdf',
    audio_en: 'audio/en/WC Climate Change Response Strategy Biennial M&E Report (2017-18)_1 (1)_en.mp3',
    audio_af: 'audio/af/WC Climate Change Response Strategy Biennial M&E Report (2017-18)_1 (1)_af.mp3',
    audio_xh: 'audio/xh/WC Climate Change Response Strategy Biennial M&E Report (2017-18)_1 (1)_xh.mp3'
  },
  {
    id: 9,
    name: 'WC Sustainable Water Management Plan 2018',
    summary: 'shortsummary/WC Sustainable Water Management Plan 2018.html',
    link: 'WC Sustainable Water Management Plan 2018.pdf',
    audio_en: 'audio/en/WC Sustainable Water Management Plan 2018_en.mp3',
    audio_af: 'audio/af/WC Sustainable Water Management Plan 2018_af.mp3',
    audio_xh: 'audio/xh/WC Sustainable Water Management Plan 2018_xh.mp3'
  },
  {
    id: 10,
    name: 'Western Cape Climate Change Mitigation Scenarios for the Energy Scenarios_Report_2015',
    summary: 'shortsummary/Western_Cape_Climate_Change_Mitigation_Scenarios_for_the_Energy_Scenarios_Report_2015.html',
    link: 'Western Cape Climate Change Mitigation Scenarios for the Energy Scenarios_Report_2015.pdf',
    audio_en: 'audio/en/Western Cape Climate Change Mitigation Scenarios for the Energy Scenarios_Report_2015_en.mp3',
    audio_af: 'audio/af/Western Cape Climate Change Mitigation Scenarios for the Energy Scenarios_Report_2015_af.mp3',
    audio_xh: 'audio/xh/Western Cape Climate Change Mitigation Scenarios for the Energy Scenarios_Report_2015_xh.mp3'
  },
  {
    id: 11,
    name: 'CCA-Africa-Final',
    summary: 'shortsummary/CCA-Africa-Final.html',
    link: 'CCA-Africa-Final.pdf',
    audio_en: 'audio/en/CCA-Africa-Final_en.mp3',
    audio_af: 'audio/af/CCA-Africa-Final_af.mp3',
    audio_xh: 'audio/xh/CCA-Africa-Final_xh.mp3'
  },
  {
    id: 12,
    name: 'Climate Change Response Strategy_M&E Report_2015-16',
    summary: 'shortsummary/Climate Change Response Strategy_M&E Report_2015-16.html',
    link: 'Climate Change Response Strategy_M&E Report_2015-16.pdf',
    audio_en: 'audio/en/Climate Change Response Strategy_M&E Report_2015-16_en.mp3',
    audio_af: 'audio/af/Climate Change Response Strategy_M&E Report_2015-16_af.mp3',
    audio_xh: 'audio/xh/Climate Change Response Strategy_M&E Report_2015-16_xh.mp3'
  },
  {
    id: 13,
    name: 'Green BCSA',
    summary: 'shortsummary/Green BCSA.html',
    link: 'Green BCSA.pdf',
    audio_en: 'audio/en/Green BCSA_en.mp3',
    audio_af: 'audio/af/Green BCSA_af.mp3',
    audio_xh: 'audio/xh/Green BCSA_xh.mp3'
  },
  {
    id: 14,
    name: 'WCCCRS (CCC Response Strategy)',
    summary: 'shortsummary/WCCCRS (CCC Response Strategy).html',
    link: 'WCCCRS (CCC Response Strategy).pdf',
    audio_en: 'audio/en/WCCCRS (CCC Response Strategy)_en.mp3',
    audio_af: 'audio/af/WCCCRS (CCC Response Strategy)_af.mp3',
    audio_xh: 'audio/xh/WCCCRS (CCC Response Strategy)_xh.mp3'
  }
];